var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"container-ans",on:{"click":_vm.openLink}},[_c('span',[_vm._v(" ANS - Nº "+_vm._s(_vm.config.aplicacao.numeroAns)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }